export type definitionWord = {
  'term': string,
  'definition': string
}

export type definitionWords = definitionWord[]

export function convertDefinitionWords(wordlist: definitionWords, text:string, key:string):string {
  let convertedText:string = text;
  if (wordlist != undefined) {
    wordlist.forEach((v, k) => {
      const regex = new RegExp(`\\[definition for="${v.term}"\\]`, "g");
      convertedText = convertedText.replace(
        regex,
        `placeholder_${k}`
      );
    })

    wordlist.forEach((v, k) => {
      const regex = new RegExp(`placeholder_${k}`);

      while (convertedText.match(regex)) {
        const indexOfFirst = convertedText.indexOf(`placeholder_${k}`);
        convertedText = convertedText.replace(
          regex,
          `<button class="dfn" aria-controls="a11y-dfn-${indexOfFirst}" aria-expanded="false">
          <span class="sr-text">Lees definitie van </span>
          ${v.term}
          </button>
          <span id="a11y-dfn-${indexOfFirst}" aria-hidden="true" class="dfn__meaning text--s">
          <span class="dfn__inner">${v.definition}</span>
          </span>`    
        );
      }
    })
  }

  return convertedText;
}



// WEBPACK FOOTER //
// ./Client/components/public_site/blocks/custom_blocks/utils.mod.tsx